import createElement from "../../createElement";

/**
 * @typedef {Object} CustomNoRowsOverlayParams
 * @property {() => GridInstance} getInstance - Returns the final grid instance after initialization
 */

// noinspection JSUnusedGlobalSymbols
/**
 * A starting point custom no rows overlay to display different messages based on
 * current filter values
 */
class CustomNoRowsOverlay {
	/**
	 * @type {
	 * 		import('ag-grid-community/dist/lib/rendering/overlays/noRowsOverlayComponent').INoRowsOverlayParams &
	 * 		CustomNoRowsOverlayParams
	 * 	}
	 */
	params;

	init(params) {
		this.params = params;
	}

	getGui() {
		let message = '';
		if (this.params && this.params.getInstance() && this.params.getInstance()._initialized) {
			const instance = this.params.getInstance();
			const filterValues = instance._getFilterValues();

			if (filterValues && filterValues.search) {
				// Search has a value
				message = 'No Results Found';
			} else {
				// Search has no value
				message = 'Nothing Here';
			}
		}
		return createElement(`<div>${message}</div>`)
	}
}


export {CustomNoRowsOverlay}
